export enum FlowScope {
  Enrollment = "enrollment",
  UpdatePaymentMethod = "update-payment-method",
  Documents = "documents",
  Billing = "billing",
  Renewal = "renewal",
  ConnectBattery = "connect-battery",
}

const FLOW_SCOPE_VALUES = new Set<string>(Object.values(FlowScope));

export function isFlowScope(value: string): value is FlowScope {
  return FLOW_SCOPE_VALUES.has(value);
}

export function parseFlowScope(
  value: string | null | undefined,
): FlowScope | null {
  if (value === null || value === undefined) {
    return null;
  }

  return isFlowScope(value) ? value : null;
}
